import { getDateFromDashSafe } from "../../Pages/ResultPage/base";

function hasAnyNonSpecialChars(value) {
    const stringVal = String(value);

    return (
        stringVal.trim().length > 0 &&
        /[\p{L}\p{N}]/u.test(stringVal)
    );
}

const fuels = {
    petrol: 'Benzín',
    diesel: 'Nafta',
    electro: 'Elektřina',
}

const getPaliva = (PalivoKostka, FuelEz) => {
    if (!PalivoKostka && !FuelEz) return [];
    const valUpper = String(PalivoKostka).toUpperCase();
    const mappingTable = {
        "BA": fuels.petrol,
        "NM": fuels.diesel,
        "EL": fuels.electro,
    };
    const keys = Object.keys(mappingTable);
    const final = new Set();
    for (const key of keys) {
        if (valUpper.includes(key)) {
            final.add(mappingTable[key]);
        }
    }

    const fuel = String(FuelEz).toUpperCase();
    if (fuel.includes("PETROL")) {
        final.add(fuels.petrol);
    }
    if (fuel.includes("DIESEL")) {
        final.add(fuels.diesel);
    }

    return Array.from(final);
}

export default function getResultData(results) {
    const { base, ez_vehicle, ez } = results || {};
    const { TovarniZnacka, ObchodniOznaceni, Palivo } = base || {};
    const { make, model, fuel } = ez_vehicle || {};
    const { manufactured: ez_vm } = ez_vehicle || {};

    const znacka = TovarniZnacka ?? make;
    const model_auta = ObchodniOznaceni ?? model;

    const manufactured = getDateFromDashSafe(hasAnyNonSpecialChars(ez?.bs?.m) ? ez?.bs?.m : ez_vm);

    const paliva = getPaliva(Palivo, fuel);

    return { znacka, model: model_auta, manufactured, paliva };
}

export const isResultSamplePage = () => {
    const pathname = window.location.pathname;
    if (pathname.includes("/result/sample")) {
        return true;
    }
    return false;
}

export const isResultPage = () => {
    const pathname = window.location.pathname;
    if (pathname.includes("/result/")) {
        return true;
    }
    return false;
}
